import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
              <i className="ri-question-line" aria-hidden="true"></i>
              FAQ
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
              关于这片甜瓜田
              <br />
              你可能想问
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              还有别的疑问？写信到 hello@tangxinchigua.com，编辑组会挑常见的问题补充到这里。
            </p>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-300' : 'border-background-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-4 md:px-6 py-4 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-900">{item.q}</span>
                    <i
                      className={`shrink-0 text-xl transition-transform ${
                        isOpen ? 'ri-subtract-line text-primary-500' : 'ri-add-line text-foreground-500'
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}